import { createContext, useContext } from 'react';

/**
 * Files attached in this browser session, by SHA-256, so a Load card sends the exact file the agent saw.
 * Files are never stored by the agent; after a reload the card asks for the file again and checks its hash.
 */
export interface AgentFiles {
  get: (sha256: string) => File | undefined;
}

export const AgentFilesContext = createContext<AgentFiles>({ get: () => undefined });
export const useAgentFiles = () => useContext(AgentFilesContext);
